import { Navigate } from "react-router-dom";

const AppRoute = ({ layout: Layout, component: Component, auth, ...rest }) => {
  const isAuthenticated = auth !== "no";

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return (
    <Layout>
      <Component {...rest} />
    </Layout>
  );
};

export default AppRoute;
